<script setup lang="ts">

</script>

<template>
  <div class="social-media order-2 md:order-1">
    <div class="block">
      <h4 class="h3 text-lg md:text-xl lg:text-2xl 3xl:h3 text-primary mb-2 lg:mb-6"> {{ $t("footer.socialMedia.headerText") }} </h4>
      <div class="flex gap-[12px] justify-center md:justify-start">
        <NuxtLink
          to="https://www.instagram.com/mysofabed.de/"
          target="_blank"
          class="group"
          :aria-label="$t('footer.socialMedia.ariaLabelInstagram')">
          <i class="icon-instagram pl-[1px] text-8xl text-grey-600 bg-gradient-to-r from-[#833ab4] via-[#fd1d1d] to-[#fcb045] bg-clip-text group-hover:text-transparent transition duration-300" aria-hidden="true"></i>
        </NuxtLink>
        <NuxtLink
          to="https://www.facebook.com/www.mysofabed.de/"
          target="_blank"
          class="text-grey-600 group transition-colors duration-300"
          :aria-label="$t('footer.socialMedia.ariaLabelFacebook')">
          <i class="icon-facebook pl-[1px] text-8xl text-grey-600 bg-gradient-to-r from-[#1877F2] via-[#1877F2] to-[#1877F2] bg-clip-text group-hover:text-transparent transition duration-300" aria-hidden="true"></i>
        </NuxtLink>
        <!-- Note: Uncomment the below section to add linked in -->
        <!-- <NuxtLink
          to="#"
          target="_blank"
          class="group"
          :aria-label="$t('footer.socialMedia.ariaLabelLinkedin')">
          <i class="icon-linkedin pl-[1px] text-8xl text-grey-600 bg-gradient-to-r from-[#0077B5] via-[#0077B5] to-[#0077B5] bg-clip-text group-hover:text-transparent transition duration-300" aria-hidden="true"></i>
        </NuxtLink> -->
        <NuxtLink
          to="https://www.youtube.com/channel/UC9Hw_AT8JDgeTvJY6vZB7KQ"
          target="_blank"
          class="group"
          :aria-label="$t('footer.socialMedia.ariaLabelLinkedin')">
          <i class="icon-youtube pl-[1px] text-8xl text-grey-600 bg-gradient-to-r from-[#FF0000] via-[#FF0000] to-[#FF0000] bg-clip-text group-hover:text-transparent transition duration-300" aria-hidden="true"></i>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>